<template>
    <el-main class="main-con el-main lender-home">
        <nav-breadcrumb :menu="[{label: '首页'}]" :back-button-visible="false"/>
        <div class="el-main-x-width-auto">
            <!--<div class="panel_ywtj of">-->
                <!--<div class="panel_ywtj_head of fwb">-->
                    <!--<p>业务统计</p>-->
                <!--</div>-->
            <!--</div>-->

            <ul class="panel_ywtj_con of">
                <li class="panel_ywtj_con_item">
                    <div class="ywtj_list_details of out">
                        <div class="ywtj_icon_wrap ywtj_icon_bg01 fl">
                            <img src="../../assets/images/img17.png" alt="">
                        </div>
                        <div class="ywtj_mesg fr">
                            <div class="ywtj_num"><span>{{variables.Customers}}</span>位</div>
                            <div class="ywtj_bijiao"><span class="fwb" style="font-size: 14px">累计</span>客户数<span class="color-danger">（较上月+{{this.variables.NewCustomers}}）</span></div>
                        </div>
                    </div>
                    <div class="ywtj_list_details of in">
                        <div class="ywtj_icon_wrap ywtj_icon_bg01 fl">
                            <img src="../../assets/images/img17-2.png" alt="">
                        </div>
                        <div class="ywtj_mesg fr">
                            <div class="ywtj_num"><span>{{variables.ActiveCustomers}}</span>位</div>
                            <div class="ywtj_bijiao"><span class="fwb" style="font-size: 14px">签约中</span>客户数</div>
                        </div>
                    </div>
                </li>
                <li class="panel_ywtj_con_item">
                    <div class="ywtj_list_details of out">
                        <div class="ywtj_icon_wrap ywtj_icon_bg02 fl">
                            <img src="../../assets/images/img18.png" alt="">
                        </div>
                        <div class="ywtj_mesg fr">
                            <div class="ywtj_num"><span>{{variables.FinancingCounts}}</span>笔</div>
                            <div class="ywtj_bijiao"><span class="fwb" style="font-size: 14px">累计</span>签约合同<span class="color-danger">（较上月+{{variables.NewFinancingCounts}}）</span></div>
                        </div>
                    </div>
                    <div class="ywtj_list_details of in">
                        <div class="ywtj_icon_wrap ywtj_icon_bg02 fl">
                            <img src="../../assets/images/img18-2.png" alt="">
                        </div>
                        <div class="ywtj_mesg fr">
                            <div class="ywtj_num"><span>{{variables.ActiveFinancingCounts}}</span>笔</div>
                            <div class="ywtj_bijiao"><span class="fwb" style="font-size: 14px">在途</span>签约合同</div>
                        </div>
                    </div>
                </li>
                <li class="panel_ywtj_con_item">
                    <div class="ywtj_list_details of out">
                        <div class="ywtj_icon_wrap ywtj_icon_bg03 fl">
                            <img src="../../assets/images/img19.png" alt="">
                        </div>
                        <div class="ywtj_mesg fr">
                            <div class="ywtj_num"><span>{{variables.FinancingValues/10000|formatMoney}}</span>万元</div>
                            <div class="ywtj_bijiao"><span class="fwb" style="font-size: 14px">累计</span>放款总额<span class="color-danger">（较上月+{{variables.NewFinancingValues/10000|formatMoney}}万元）</span></div>
                        </div>
                    </div>
                    <div class="ywtj_list_details of in">
                        <div class="ywtj_icon_wrap ywtj_icon_bg03 fl">
                            <img src="../../assets/images/img19-2.png" alt="">
                        </div>
                        <div class="ywtj_mesg fr">
                            <div class="ywtj_num"><span>{{variables.ActiveFinancingValues/10000|formatMoney}}</span>万元</div>
                            <div class="ywtj_bijiao"><span class="fwb" style="font-size: 14px">实时</span>贷款余额</div>
                        </div>
                    </div>
                </li>
                <li class="panel_ywtj_con_item">
                    <div class="ywtj_list_details of out">
                        <div class="ywtj_icon_wrap ywtj_icon_bg04 fl">
                            <img src="../../assets/images/img20-2.png" alt="">
                        </div>
                        <div class="ywtj_mesg fr">
                            <div class="ywtj_num"><router-link :to="{name: 'FangReportingOverdueListView'}"><span>{{variables.OverdueFinancingCounts}}</span>笔</router-link></div>
                            <div class="ywtj_bijiao"><span class="fwb" style="font-size: 14px">当前</span>逾期</div>
                        </div>
                    </div>
                    <div class="ywtj_list_details of in">
                        <div class="ywtj_icon_wrap ywtj_icon_bg04 fl">
                            <img src="../../assets/images/img20.png" alt="">
                        </div>
                        <div class="ywtj_mesg fr">
                            <div class="ywtj_num"><span>{{variables.ThisYearFinancingValues/10000|formatMoney}}</span>万元</div>
                            <div class="ywtj_bijiao"><span class="fwb" style="font-size: 14px">本年度</span>放款金额</div>
                        </div>
                    </div>
                </li>
            </ul>

            <el-row :gutter="10" class="grid-content">
                <el-col :lg="7" :xl="7"><div class="bg-purple">
                    <div class="panel_ywtj_head of fwb" >
                        <P>待办事项</P>
                        <div @click="openDialog()" style="float:right;font-weight: 400;cursor: pointer">在途申请</div>
                    </div>
                    <ul class="panel_dbsx_list of">
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount1"><router-link :to="{name: 'CustomerApplyingListFangView'}">待审核进件</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount1">待审核进件</div>
                            <div :class="['panel_dbsx_num', {on: variables.ApplyingCustomers > 0}]">{{variables.ApplyingCustomers}}</div>
                            <!--数值大于0 加 on-->
                            <div class="panel_dbsx_unit">笔</div>
                        </li>
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount2"><router-link :to="{name: 'FinancingListView'}">待审核签约</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount2">待审核签约</div>

                            <div :class="['panel_dbsx_num', {on: variables.ApplyingFinancing > 0}]">{{variables.ApplyingFinancing}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount3"><router-link :to="{name: 'ApplyingRepaymentList'}">待审核还款</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount3">待审核还款</div>


                            <div :class="['panel_dbsx_num', {on: variables.ApplyingRepayOverdue > 0}]">{{variables.ApplyingRepayOverdue}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount4"><router-link :to="{name: 'ApplyingRepaymentInAdvanceList'}">待审核提前还款</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount4">待审核提前还款</div>

                            <div :class="['panel_dbsx_num', {on: variables.ApplyingRepayinAdvance > 0}]">{{variables.ApplyingRepayinAdvance}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount5"><router-link :to="{name: 'LoanApprovalListView'}">待审核用款</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount5">待审核用款</div>
                            <div :class="['panel_dbsx_num', {on: variables.ApplyingFinancingPayment > 0}]">{{variables.ApplyingFinancingPayment}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount6"><router-link :to="{name: 'FinancingRequestListView'}">待分配申贷</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount6">待分配申贷</div>
                            <div :class="['panel_dbsx_num', {on: variables.ApplyingFinancingRequest > 0}]">{{variables.ApplyingFinancingRequest}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount7"><router-link :to="{name: 'HisWarrantApproveListView'}">待审核他项</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount7">待审核他项</div>
                            <div :class="['panel_dbsx_num', {on: variables.ApplyingHisWarrantCheckout > 0}]">{{variables.ApplyingHisWarrantCheckout}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount8"><router-link :to="{name: 'AllocationCandidatesListView'}">被拒贷</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount8">已被拒贷</div>
                            <div :class="['panel_dbsx_num', {on: variables.LenderRejected > 0}]">{{variables.LenderRejected}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>
                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount9"><router-link :to="{name: 'ContractSealProcessListView'}">待审核用印</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount9">待审核用印</div>
                            <div :class="['panel_dbsx_num', {on: variables.ApplyingSeal > 0}]">{{variables.ApplyingSeal}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>

                        <li>
                            <div class="panel_dbsx_name" v-if="boolCount10"><router-link :to="{name: 'ApproveEquitySwapTxListView'}">待审核债转</router-link></div>
                            <div class="panel_dbsx_name" v-if="!boolCount10">待审核债转</div>
                            <div :class="['panel_dbsx_num', {on: variables.EquitySwapTx > 0}]">{{variables.EquitySwapTx}}</div>
                            <div class="panel_dbsx_unit">笔</div>
                        </li>

                    </ul>
                </div></el-col>
                <el-col :lg="10" :xl="10"><div class="bg-purple">
                    <div class="panel_ywtj_head of fwb">
                        <P>意向进件</P>
                        <router-link class="statistics-more" :to="{name:'CustomerApplyingListFangView'}">更多>></router-link>
                    </div>
                    <div class="panel_xzkh of">
                        <data-table
                            :table-data="tableData"
                            :columns="columns"
                            :is-pagination-show="false"
                        />
                    </div>
                </div></el-col>
                <el-col :lg="7" :xl="7"><div class="bg-purple">
                    <div class="panel_ywtj_head of fwb">
                        <P>到期贷款提醒</P>
                        <div style="float:right">
                            <el-button @click="changePage(-1)" style="border:none;background:none;padding:0 5px;"> < </el-button>
                            {{page}}/{{Math.ceil(tableData1.count/pageSize)}}
                            <el-button @click="changePage(1)" style="border:none;background:none;padding:0 5px;"> > </el-button>
                        </div>
                    </div>
                    <div class="panel_xzkh of">
                        <data-table
                            :table-data="tableData1"
                            :columns="columns1"
                            :page.sync="page"
                            :pageSize.sync="pageSize"
                            :is-pagination-show="false"
                        />
                    </div>
                </div></el-col>
            </el-row>
            <el-row :gutter="10" class="grid-content">
                <el-col :span="10"><div class="bg-purple">
                    <div class="panel_ywtj_head of fwb">
                        <P>贷款月度统计</P>
                    </div>
                    <div class="charts_size of">
                        <div id="myChart1" :style="{height: '345px'}"></div>
                    </div>
                </div></el-col>
                <el-col :span="7"><div class="bg-purple">
                    <div class="panel_ywtj_head of fwb">
                        <P>按还款方式</P>
                    </div>
                    <div class="charts_size of">
                        <ve-pie :data="chartData02" :settings="chart02"></ve-pie>
                    </div>
                </div></el-col>
                <el-col :span="7"><div class="bg-purple">
                    <div class="panel_ywtj_head of fwb">
                        <P>按贷款产品年限</P>
                    </div>
                    <div class="charts_size of">
                        <ve-pie :data="chartData03" :settings="chart03"></ve-pie>
                    </div>
                </div></el-col>
            </el-row>
        </div>
        <el-dialog title="在途申请" v-if="dialogShow" append-to-body :visible.sync="dialogShow"  @close="dialogShow=false">
            <panel title="客户进件">
                <data-table
                    :table-data="tableDataList1"
                    :columns="columnsList1"
                    :is-pagination-show="false"
                />
            </panel>
            <panel title="签约">
                <data-table
                    :table-data="tableDataList2"
                    :columns="columnsList2"
                    :is-pagination-show="false"
                />
            </panel>
            <panel title="用印">
                <data-table
                    :table-data="tableDataList3"
                    :columns="columnsList3"
                    :is-pagination-show="false"
                />
            </panel>
            <panel title="用款">
                <data-table
                    :table-data="tableDataList4"
                    :columns="columnsList4"
                    :is-pagination-show="false"
                />
            </panel>
            <panel title="减免/延期还款">
                <data-table
                    :table-data="tableDataList5"
                    :columns="columnsList5"
                    :is-pagination-show="false"
                />
            </panel>
            <panel title="提前还款">
                <data-table
                    :table-data="tableDataList6"
                    :columns="columnsList6"
                    :is-pagination-show="false"
                />
            </panel>
            <panel title="他项出库">
                <data-table
                    :table-data="tableDataList7"
                    :columns="columnsList7"
                    :is-pagination-show="false"
                />
            </panel>
        </el-dialog>
    </el-main>
</template>

<script>
    import xhr from "../../utils/xhr";
    import moment from 'moment'
    import {formatMoney} from "../../filters/CommonFilters";
    import Status2CN from "../../filters/Status2CN";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Panel from "../../components/Panel";

    export default {
        components: {Panel},
        data() {
            return {
                tableDataList1:{},
                tableDataList2:{},
                tableDataList3:{},
                tableDataList4:{},
                tableDataList5:{},
                tableDataList6:{},
                tableDataList7:{},
                columnsList1:[
                    {
                    type: 'index'
                    },
                    {
                        label: '客户姓名',
                        field: 'ba__customerName'
                    },
                    {
                        label: '手机号',
                        field: 'ba__customerContactNo'
                    },
                    {
                        label: '身份证号码',
                        field: 'ba__customerIC'
                    },

                    {
                        label: '进件时间',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm')
                        }
                    },
                    {
                        label: '当前待审批节点',
                        field: 't__nodeName',
                        formatter: function (r,c,v) {
                            if(r.t__applicationStatus=='Rejected'){
                                v=''
                            }
                            return v
                        }
                    },],
                columnsList2:[
                    {
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },
                    {
                        label: '贷款金额',
                        field: 'fi__totalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        },
                    },
                    {
                        label: '开始日期',
                        field: 'fi__startDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '结束日期',
                        field: 'fi__endDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '当前待审批节点',
                        field: 'fi__nodeName',
                        formatter: function (r,c,v) {
                            if(r.fi__transactionStatus=='Rejected'){
                                v=''
                            }
                            return v
                        }
                    },
                ],
                columnsList3:[
                    {
                        type: 'index'
                    },
                    {
                        label: '用印类型',
                        field: 't__applicationTypeCode',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '用印日期',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '关联单号',
                        field: 'de__referenceNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'de__customerName'
                    },
                    {
                        label: '申请人',
                        field: 'u__userName'
                    },
                    {
                        label: '当前待审批节点',
                        field: 't__nodeName',
                        formatter: function (r,c,v) {
                            if(r.t__applicationStatus=='Rejected'){
                                v=''
                            }
                            return v
                        }
                    },
                ],
                columnsList4:[
                    {
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },


                    {
                        label: '申请放款金额',
                        field: 'pay__totalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        }
                    },
                    {
                        label: '申请放款日期',
                        field: 'pay__paymentDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '当前待审批节点',
                        field: 'pay__nodeName',
                        formatter: function (r,c,v) {
                            if(r.pay__applicationStatus=='Rejected'){
                                v=''
                            }
                            return v
                        }
                    },
                ],
                columnsList5:[
                    {
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__contractNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },
                    {
                        label: '申请时间',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                ],
                columnsList6:[
                    {
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__contractNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },
                    {
                        name: '提前还款日期',
                        field: 't__repayDate',
                        formatter: function (r,c,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        name: '申请时间',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                        }
                    },
                ],
                columnsList7:[
                    {
                        type: 'index'
                    },
                    {
                        label: '出库原因',
                        field: 't__reason'
                    },
                    {
                        label: '贷款编号',
                        field: 't__transactionNo'
                    },
                    {
                        label: '客户姓名',
                        field: 't__customerName'
                    },
                    {
                        label: '申请时间',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '当前待审批节点',
                        field: 't__nodeName',
                        formatter: function (r,c,v) {
                            if(r.t__applicationStatus=='Rejected'){
                                v=''
                            }
                            return v
                        }
                    },
                ],
                pageSize:7,
                page:1,
                chartData03:{},
                chart03:{},
                chartData02:{},
                chart02:{},
                options: [
                    'MerchantUserCount',
                    'ActiveCustomer',
                    'ApplyingCustomer',
                    'ActiveProduct',
                    'ApplyingFinancing',
                    'ReadyFinancing',
                    'ApplyingCustomer',
                    'FinancingCountToday',
                    'PaymentCountToday',
                    'RepaymentCountToday',
                    'NewCustomer',
                    'LenderRejected',
                ],
                reportingStatisticsValues: {},
                lineChartSetting: {
                    xAxisType: 'time'
                },
                lineChartData: {
                    columns: ['日期', '还款笔数', '提款笔数', '放款笔数'],
                    rows: [
                        { '日期': '2018-01-01', '还款笔数': 1, '提款笔数': 0, '放款笔数': 4 },
                    ]
                },
                numberCount1 :0,
                numberCount2 :0,
                numberCount3 :0,
                numberCount4 :0,
                numberCount5 :0,
                numberCount6 :0,
                tableData: {
                    count: 0,
                    data: []
                },
                Month: [],
                data1:[],
                data2:[],
                variables:{},
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '客户姓名',
                        field: 'ba__customerName',
                        width: '100px'
                    },
                    {
                        label: '手机号',
                        field: 'ba__customerContactNo'
                    },
                    {
                        label: '身份证号码',
                        field: 'ba__customerIC'
                    },
                    {
                        label: '进件时间',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm')
                        }
                    },
                ],
                columns1:[
                    {
                        type: 'index',
                        width: '35px'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName',
                        width: '90px'
                    },
                    {
                        label: '货款余额',
                        field: 'fi__balanceAmount',
                        width: '100px'
                    },
                    {
                        label: '到期日',
                        field: 'fi__endDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        },
                        width: '98px'
                    },
                    {
                        label: '货款编号',
                        field: 'fi__transactionNo',
                        formatter: function (r,c,v) {
                            return v.replace('房借字','')
                        },

                    },
                ],
                tableData1: {
                    count: 0,
                    data: []
                },
                productData1:[],
                productData2:[],
                dialogShow: false
            }
        },
        computed:{
            boolCount1: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/CustomerApplying"){
                            bool = true
                        }

                    })
                })
                return bool
            },

            boolCount2: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/Financing"){
                            bool = true
                        }

                    })
                })
                return bool
            },


            boolCount3: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/ApplyingRepaymentList"){
                            bool = true
                        }

                    })
                })
                return bool
            },


            boolCount4: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/ApplyingRepaymentInAdvanceList"){
                            bool = true
                        }

                    })
                })
                return bool
            },

            boolCount5: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/LoanApprovalList"){
                            bool = true
                        }

                    })
                })
                return bool
            },

            boolCount6: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/FinancingRequest"){
                            bool = true
                        }

                    })
                })
                return bool
            },
            boolCount7: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/HisWarrantApproveList"){
                            bool = true
                        }

                    })
                })
                return bool
            },
            boolCount8: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/AllocationCandidates"){
                            bool = true
                        }

                    })
                })
                return bool
            },

            boolCount9: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/ContractSealProcessList"){
                            bool = true
                        }

                    })
                })
                return bool
            },

            boolCount10: function() {
                let bool =false
                this.$store.state.menuData.forEach(item=>{
                    item.submenus.forEach(e=>{
                        if(e.link=="/ApproveEquitySwapTx"){
                            bool = true
                        }

                    })
                })
                return bool
            },

            filterParams: {
                get: function() {
                    return {
                        pageSize: this.pageSize,
                        pageOffset: (this.page - 1) * this.pageSize,
                    }
                },
                set:function (newVal) {

                }
            }
        },
        watch: {
            filterParams: function () {
                this.getMatureBeforeNextMonthList()
            },
        },
        mounted() {
            this.getWelcomeList()
            this.getApplyingCustomerFangList()
            this.getFinancingLast12MonthsList()
            this.getFinancingByDealerList()
            this.getFinancingByFormulaList()
           // this.getReportingStatisticsValues(this.options.join(','))
            this.getMatureBeforeNextMonthList()
            this.getFinancingByProduct()
        },
        methods: {
            openDialog(){
                xhr.getApplyingCustomerFangList(
                    Object.assign({  'xlist.search.t.applicationStatus' : 'Pending Approval', pageSize:0 }),
                    res => {
                        try {
                            this.tableDataList1 = res.data
                            this.tableDataList1.data.forEach(item=>{
                                item.t__nodeName = (this.tableDataList1.variables.procInfo.find(item2=> item2.type ===item.t__nodeType )||{}).name


                            })
                        } catch (e) {

                        }
                    })
                xhr.getFinancingFangList(
                    Object.assign({  'xlist.search.fi.transactionStatus' : 'Pending Approval',  pageSize:0 }),
                    res => {
                        try {
                            this.tableDataList2 = res.data
                            this.tableDataList2.data.forEach(item=>{
                                item.fi__nodeName = (this.tableDataList2.variables.procInfo.find(item2=>item2.type ===item.fi__nodeType )||{}).name

                            })
                        } catch (e) {

                        }
                    })
                xhr.getSealApplicationList(
                    Object.assign({'xlist.search.t.applicationStatus' : 'Pending Approval',  pageSize:0}),
                    res => {
                        try {
                            this.tableDataList3 = res.data
                            this.tableDataList3.data.forEach(item=>{
                                item.t__nodeName = (this.tableDataList3.variables.procInfo.find(item2=>item2.code ==='YY'+item.t__applicationTypeCode && item2.type ===item.t__nodeType  )||{}).name


                            })
                        } catch (e) {

                        }
                    })
                xhr.getFinancingPaymentForApprovalList(
                    Object.assign({'xlist.search.pay.applicationStatus' : 'Pending Approval',  pageSize:0}),
                    res => {
                        try {
                            this.tableDataList4 = res.data
                            this.tableDataList4.data.forEach(item=>{
                                item.pay__nodeName = (this.tableDataList4.variables.procInfo.find(item2=>item2.type ===item.pay__nodeType)||{}).name


                            })
                        } catch (e) {

                        }
                    })
                xhr.getApplyingRepayment(
                    Object.assign({'xlist.search.t.applicationStatus' : 'Pending Approval',  pageSize:0}),
                    res=> {
                        try {
                            this.tableDataList5 = res.data
                        }catch(e){

                        }
                    })
                xhr.getApplyingRepaymentInAdvanceList(
                    Object.assign({'xlist.search.t.applicationStatus' : 'Pending Approval',  pageSize:0}),
                    res=> {
                        try {
                            this.tableDataList6 = res.data
                        }catch(e){

                        }
                    })

                xhr.getHisWarrantTxList(
                    Object.assign({'xlist.search.t.applicationStatus' : 'Pending Approval','xlist.search.t.applicationTypeCode' : 'HWI',  pageSize:0}),
                    res=> {
                        try {
                            this.tableDataList7 = res.data
                            this.tableDataList7.data.forEach(item=>{
                                item.t__nodeName = (this.tableDataList7.variables.procInfo.find(item2=>item2.type ===item.t__nodeType )||{}).name


                            })
                        }catch(e){

                        }
                    })
                this.dialogShow = true
            },
            changePage:function(val){
                if((this.page+val)> Math.ceil(this.tableData1.count/this.pageSize)||(this.page+val)<1){

                }else{
                    this.page = this.page + val
                }

            },
            getWelcomeList: function () {
                xhr.getWelcomeList(
                    Object.assign({},
                        {

                        }
                        , {}),
                    res => {
                        try {

                            this.variables = res.data.variables
                        } catch (e) {

                        }
                    })
            },

//新增客户

            getApplyingCustomerFangList: function () {
                xhr.getApplyingCustomerFangList(
                    Object.assign({
                        pageSize: 7,
                        'xlist.search.t.applicationStatus' : 'Pending Approval',
                        'xlist.search.t.applicationStatus.op' : 'in',
                        'xlist.sort.dataField': 't.applicationDate',
                        'xlist.sort.order': 'desc'
                    }, {}, {}),
                    res => {
                        try {
                            this.tableData = res.data
// this.roleData = res.data.variables
                        } catch (e) {

                        }
                    })



                /*xhr.getApplyingCustomerFangList(
                Object.assign({},
                {
                pageSize: 5,
                'xlist.search.t.applicationStatus' :'Approved,Completed',
                'xlist.search.t.applicationStatus.op' : 'in',
                'xlist.sort.dataField': 't.applicationDate',
                'xlist.sort.order': 'desc'
                }
                , {}),
                res => {
                try {
                this.tableData = res.data
                } catch (e) {

                }
                })*/
            },
            getMatureBeforeNextMonthList: function () {
                xhr.getMatureBeforeNextMonthList(
                    Object.assign({
                        'xlist.sort.dataField': 'fi.endDate',
                        'xlist.sort.order': 'asc'
                    }, this.filterParams, {}),
                    res => {
                        try {
                            this.tableData1 = res.data
// this.roleData = res.data.variables
                        } catch (e) {

                        }
                    })
            },
           /* getReportingStatisticsValues: function (options) {
                xhr.getReportingStatistics(
                    {
                        options
                    },
                    res => {
                        this.reportingStatisticsValues = res.data.data
                    }
                )
            },*/

            getFinancingByProduct: function () {
                xhr.getFinancingByProduct(
                    {
                        pageSize: 0,
                    },
                    res => {
                        this.chart03 = {
                            roseType: 'radius',
                        }
                        let rows= []

                        res.data.data.forEach(item=>{
                            if(item.fi__years==0){
                                rows.push(
                                    {
                                        '年限':'其他',
                                        '数量':item.bal__balanceAmount,
                                    }
                                )
                            }else{
                                rows.push(
                                    {
                                        '年限':item.fi__years+"年期",
                                        '数量':item.bal__balanceAmount,
                                    }
                                )
                            }
                        })


                        this.chartData03 ={
                            columns: ['年限', '数量'],
                            rows: rows
                        }
                    }
                )
            },

//贷款月度统计
            getFinancingLast12MonthsList: function () {
                xhr.getFinancingLast12MonthsList(
                    Object.assign({},
                        {
                            pageSize: 0,
                        }
                        , {}),
                    res => {
                        try {
                            res.data.data.forEach(item=>{
                                this.Month.push(item.fi__month+'月')
                                this.data1.push(item.fi__counts)
                                this.data2.push(parseFloat(item.fi__values/10000).toFixed(2 ))

                            })
                            this.chart1()
                        } catch (e) {

                        }
                    })
            },
//
            getFinancingByDealerList: function () {
                xhr.getFinancingByDealerList(
                    Object.assign({},
                        {
                            pageSize: 0,
                        }
                        , {}),
                    res => {
                        try {

                        } catch (e) {

                        }
                    })

            },

            getFinancingByFormulaList: function () {
                xhr.getFinancingByFormulaList(
                    Object.assign({},
                        {
                            pageSize: 0,
                        }
                        , {}),
                    res => {
                        try {
                            this.chart02 = {
                                roseType: 'radius'
                            }
                            let rows = []
                            res.data.data.forEach(item=>{
                                rows.push(
                                    {
                                        '方式':item.fi__repaymentFormula=='DEBX'?'等额本息':'先息后本',
                                        '数量':item.fi__counts,
                                    }
                                )
                            })
                            this.chartData02 ={
                                columns: ['方式', '数量'],
                                rows:rows
                            }
                        } catch (e) {

                        }
                    })

            },
            chart1(){
                let myChart = this.$echarts.init(document.getElementById('myChart1'))
                myChart.setOption({
                    color: ['#fa6e86','#65c6f3'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#283b56'
                            }
                        }
                    },

                    legend: {
                        data: [ '贷款笔数', '贷款金额']
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.Month,
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '笔'
                        },
                        {
                            type: 'value',
                            name: '万元'
                        }
                    ],
                    series: [
                        {
                            name: '贷款笔数',
                            type: 'line',
                            smooth: true,
                            data:this.data1
                        },
                        {
                            name: '贷款金额',
                            type: 'bar',
                            yAxisIndex: 1,
                            data: this.data2
                        }
                    ]
                });
            },
        }
    }
</script>

<style scoped>
.lender-home {
    min-width: 1700px;
    /*overflow-x: scroll*/
}
</style>



// WEBPACK FOOTER //
// src/views/lender/LenderHome.vue